<template> </template>

<script>
import ConsultoriasServicos from './ConsultoriasServicos'

export default {
    props: {
        consultoria: {
            type: Object
        }
    },

    data() {
        return {
            avaliacao: null
        }
    },

    methods: {
        obterAvaliacao() {
            this.$store.dispatch('addRequest')
            ConsultoriasServicos.obterAvaliacao(
                this.$route.params.consultoriaId
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.avaliacao = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter avaliação da consultoria!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    mounted() {
        this.obterAvaliacao()
    }
}
</script>
